/**
 * Streak Hooks
 *
 * Shared React hooks for streak tracking using Convex.
 */

import { useQuery, useMutation } from 'convex/react';
import { api } from '@have-done/backend/convex/_generated/api';

/**
 * Get the current user's streak
 */
export function useStreak() {
  return useQuery(api.streaks.get);
}

/**
 * Recalculate streak (for data corrections)
 */
export function useRecalculateStreak() {
  return useMutation(api.streaks.recalculate);
}
